'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reports = require('./reports.html');

var _reports2 = _interopRequireDefault(_reports);

var _reports3 = require('./reports.controller');

var _reports4 = _interopRequireDefault(_reports3);

require('./reports.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportsComponent = {
  restrict: 'E',
  bindings: {},
  template: _reports2.default,
  controller: _reports4.default,
  controllerAs: 'vm'
};

exports.default = reportsComponent;


// WEBPACK FOOTER //
// ./client/app/components/reports/reports.component.js